import { useNavigateTo } from '../../paths/useNavigateTo';
import { path } from '../../paths';
import { Forbidden } from '../Forbidden';
import { RoleForm } from './RoleForm';
import { useCallback } from 'react';
import { RoleDto, useIsAdmin } from '@atlas-frontend/sdk';

export const RoleCreate = () =>
  !useIsAdmin() ? <Forbidden /> : <RoleCreateInner />;

export const RoleCreateInner = () => {
  const navigateToRoleDirectory = useNavigateTo(path.roleDirectory);
  const navigateToRoleDetails = useNavigateTo(path.roleDetails);

  const handleCancel = useCallback(() => {
    navigateToRoleDirectory();
  }, [navigateToRoleDirectory]);
  const handleSuccess = useCallback(
    (response: RoleDto) => {
      navigateToRoleDetails(
        { id: response.id },
        { state: { saved: 'success', noBlocker: true } }
      );
    },
    [navigateToRoleDetails]
  );

  if (!useIsAdmin()) {
    return <Forbidden />;
  }

  return (
    <RoleForm
      mode="create"
      onClickCancel={handleCancel}
      onSuccess={handleSuccess}
      defaultValues={defaultRole}
    />
  );
};

const defaultRole: RoleDto = {
  id: '' as any,
  name: '',
  description: '',
  createdAt: null,
  createdBy: null,
  modifiedAt: null,
  modifiedBy: null,
  permissions: [],
  accessGroups: [],
};
